// @flow
import moment from "moment";

import { buildLicenceItemJson } from "../companies/CompileCompanytoJson";

export function buildProjectItemJson(project: *): * {
  let json = {};
  json.id = project.id;
  json.project_name = project.name;

  json.closeDateOrigin = project.closeDate;
  json.closeDate = moment.utc(project.closeDate).local().format("DD/MMM/YYYY hh:mm A");
  json.createDateOrigin = project.auditCreationDate;
  json.createdDate = moment.utc(project.auditCreationDate).local().format("DD/MMM/YYYY hh:mm A");

  json.noOfStreams = project.noOfStreams || "";
  json.noOfFaces = project.noOfFaces || "";
  json.notes = project.notes;

  json.postcode = project.postcode || "";
  json.address = project.address || "";
  json.suburb = project.suburb || "";
  json.city = project.city || "";
  json.state = project.state || "";
  json.country = project.country || "";

  json.createdCompany = project.company;
  json.resellerCompany = project.reseller;
  json.enduserCompany = project.enduser;

  json.outcome = project.outcome;
  json.closeStatus = project.closeStatus;
  json.closeStatusOther = project.closeStatusOther;
  json.actualCloseDateOrigin = project.actualCloseDate;
  json.actualCloseDate = moment.utc(project.actualCloseDate).local().format("DD/MMM/YYYY hh:mm A");

  json.quotes = project.quotes.edges && project.quotes.edges.map(quote => quote.node.id);
  json.licence = project.licence.edges && project.licence.edges.map(licence => buildLicenceItemJson(licence.node));
  return json;
}
